import {
  Column,
  DayType,
  DaysType,
  Item,
  MainFieldType,
  OrderType,
} from './schemas';

export const transitiveDateTypes = [
  'daily',
  'weekly',
  'monthly',
  'any',
] as const;
export type TransitiveDateType = (typeof transitiveDateTypes)[number];

export type DataTerminalTransitionParams = {
  mainField?: MainFieldType;
  transitiveFields?: string[];
  nonTransitiveFields?: string[];
  marking?: string;
  areas?: string[];
  halls?: string[];
  dateType?: TransitiveDateType;
  durationForAnyDateType?: number;
  startDate?: string;
  endDate?: string;
  excludeToday?: boolean;
  days?: DaysType[];
  dayType?: DayType;
  dateSuffixes?: number[];
  dates?: number[];
  shuGroupIds?: string[];
  shuList?: string[];
  shuGroupIdsForSijiritu?: string[];
  shuListForSijiritu?: string[];
  sortForHeader?: string;
  sortForTransitiveField?: string;
  order?: OrderType;
  isFiltering?: boolean;
};

export type DataTerminalTransitionData = {
  columnsForNonTransition: Column[];
  columnsForTransition: Column[];
  dates: {
    name: string;
    code: string;
    backgroundColor: string | null;
  }[];
  rows: {
    queryParameter: {
      shuList?: string[];
      shuGroupIds?: string[];
      halls?: string[];
    };
    dataForNonTransition: Item[];
    dataForTransition: Item[][];
  }[];
};

export type DataTerminalTransitionDataQueryParameter =
  DataTerminalTransitionData['rows'][0]['queryParameter'];

export type DataTerminalTransition = {
  setting: Required<DataTerminalTransitionParams>;
  data: DataTerminalTransitionData;
};
